import { Component } from '@angular/core';

import { useDispatcher } from '../../../../store.decorator';
import { View } from '../../enum/view.enum';
import { switchView } from '../../state/switch-view.action';
import { TranscriptDialogService } from '../../transcript-dialog.service';

import { TranslationKeyMap } from './landing.i18n';

@Component({
    selector: 'cmps-transcript-dialog-landing',
    templateUrl: './landing.component.html',
    host: {
        class: 'cmps-transcript-dialog-landing',
    },
})
export class LandingComponent {
    /** @private */ _i18n = TranslationKeyMap;

    constructor(/** @private */ readonly _service: TranscriptDialogService) {}

    /** @private */
    _onCreateNotesClick(): void {
        useDispatcher(this._service, switchView({ view: View.NOTES }));
    }
}
